"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MysqlDataMigration", {
    enumerable: true,
    get: function() {
        return MysqlDataMigration;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _datamigrationhelper = require("~/services/formula-column-type-changer/data-migration.helper");
const _utils = require("~/utils");
const _formulaQueryBuilderv2 = /*#__PURE__*/ _interop_require_default(require("~/db/formulav2/formulaQueryBuilderv2"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let MysqlDataMigration = class MysqlDataMigration {
    async migrate({ baseModelSqlV2, formulaColumn, destinationColumn, formulaColumnOption, offset, limit }) {
        const knex = baseModelSqlV2.dbDriver;
        const formulaColumnAlias = '__nc_formula_value';
        const idOffsetTableAlias = 'id_offset_tbl';
        const formulaValueTableAlias = 'formula_value_tbl';
        const idOffsetTable = (0, _datamigrationhelper.getIdOffsetTable)({
            baseModelSqlV2,
            alias: idOffsetTableAlias,
            limit,
            offset
        });
        const formulaValueTable = knex(baseModelSqlV2.getTnPath(baseModelSqlV2.model.table_name, formulaValueTableAlias)).select(_extends({
            [formulaColumnAlias]: (await (0, _formulaQueryBuilderv2.default)({
                baseModel: baseModelSqlV2,
                tree: formulaColumnOption.formula_raw,
                model: baseModelSqlV2.model,
                column: formulaColumn,
                validateFormula: false,
                parsedTree: formulaColumnOption.getParsedTree()
            })).builder
        }, (0, _datamigrationhelper.getPrimaryKeySelectColumns)({
            model: baseModelSqlV2.model,
            sourceTable: formulaValueTableAlias
        }))).innerJoin(knex.raw(`?? as ${idOffsetTableAlias}`, [
            knex.raw(idOffsetTable).wrap('(', ')')
        ]), function() {
            for (const primaryColName of Object.keys((0, _datamigrationhelper.getPrimaryKeySelectColumns)({
                model: baseModelSqlV2.model
            }))){
                this.on(`${idOffsetTableAlias}.${primaryColName}`, '=', `${formulaValueTableAlias}.${primaryColName}`);
            }
        });
        // knex qb is not yet support update select / update join
        // so we need to compose them manually (sad)
        const qb = knex.raw(`update ?? inner join (??) ?? on ?? set ?? = ??`, [
            baseModelSqlV2.getTnPath(baseModelSqlV2.model, _utils.ROOT_ALIAS),
            knex.raw(formulaValueTable),
            knex.raw(`as ${formulaValueTableAlias}`),
            knex.raw(baseModelSqlV2.model.primaryKeys.map((col)=>{
                return knex.ref(`${_utils.ROOT_ALIAS}.${col.column_name}`).toQuery() + '=' + knex.ref(`${formulaValueTableAlias}.${col.column_name}`).toQuery();
            }).join(' and ')),
            knex.raw(knex.ref(destinationColumn.column_name)),
            knex.raw(knex.ref(`${formulaValueTableAlias}.${formulaColumnAlias}`))
        ]);
        await baseModelSqlV2.execAndParse(qb.toQuery(), null, {
            raw: true
        });
        return await (0, _datamigrationhelper.getUpdatedRows)({
            baseModelSqlV2,
            alias: idOffsetTableAlias,
            destinationColumn,
            limit,
            offset
        });
    }
    constructor(){
        this.dbDriverName = _nocodbsdk.ClientType.MYSQL;
    }
};
